import {FC, useState} from 'react'
import {toast} from 'react-toastify'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import * as AssetAction from '../redux/AssetAction'
import {AssetModel, AssetTableModelInitValues} from '../models/AssetModel'

interface Props {
  show: boolean
  handleClose: () => void
  asset: AssetModel
}

export const AssetDelete: FC<Props> = ({show, handleClose, asset}) => {
  let navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const dispatch: any = useDispatch()
  const removeAsset = () => {
    setLoading(true)
    dispatch(AssetAction.remove(asset._id, AssetTableModelInitValues))
      .then((response: any) => {
        toast.success(response)
        setLoading(false)
        navigate('/assets')
      })
      .catch((error: any) => {
        toast.error(error)
        setLoading(false)
      })
    handleClose()
  }

  return (
    <Modal
      id='kt_modal_delete_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-500px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Delete Asset</h2>
        </div>

        <div className='modal-body flex-row-fluid py-lg-10 px-lg-10'>
          <p className='d-flex align-items-center fs-5 fw-bold'>
            Are you sure you want to delete this asset {asset?.number}?
          </p>
          <div className='d-flex flex-stack mt-5'>
            <button
              type='button'
              className='btn btn-lg btn-light-primary float-left'
              onClick={() => {
                handleClose()
              }}
            >
              Cancel
            </button>
            <button
              title='Delete'
              type='submit'
              className='btn btn-lg btn-primary float-left'
              onClick={() => {
                removeAsset()
              }}
              disabled={loading}
            >
              <span className='indicator-label'>{loading ? 'Deleting...' : 'Delete'}</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default AssetDelete
